import React, {useState, useEffect} from 'react'
import {httpGet, httpPost} from '../shared/Config';
import { useTranslation } from 'react-i18next';
import SimpleModal from "./SimpleModal";

function DeleteApiKeyModal({isOpen, onCancel, orgId, user, apiKey, onOk, title, children, processing}) {

    const {t} = useTranslation();

    const [error, setError] = useState("");
    const [working, setWorking] = useState(false);

    function deleteKey(e, apiK) {
        setError("");
        setWorking(true);
        async function deleteK() {
            const response = await httpPost(`/orgs/${orgId}/deleteKey`, {user, apiKey});
            if(response.data.status === "success") {
                onOk(apiKey.id);
                setWorking(false);
            } else {
                setError("ERROR_DELETING_KEY");
            }
            setWorking(false);
        }
        deleteK();
    }

    return (
        <SimpleModal isOpen={isOpen}>
            <h3>
                {t(title)}
            </h3>
            <div>
                {
                    apiKey ? <React.Fragment>{t('KEy_TO_DELETE')} WebId: <b>{apiKey.webId}</b></React.Fragment> : null
                }
                <br/>
                {children}
                {
                    error ? <React.Fragment>
                        <span className="error">{error}</span>
                    </React.Fragment> : null
                }
            </div>
            <div className={'modal-action'}>
                <button className={'btn btn-primary'} disabled={working || !apiKey} color="primary" onClick={deleteKey}>{t('OK')}</button>
                <button className={'btn'
                } disabled={working} color="secondary" onClick={onCancel}>{t('CANCEL')}</button>
            </div>
        </SimpleModal>
    )
}

export default DeleteApiKeyModal;
